import * as React from 'react';
import { getFormatDateFromStoreDate } from 'shared-components';
import { Section } from '../../../../Finger/Section';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../../utilities/documents';
import FingerWithApprove from '../../../../atoms/finger-with-approve';
import NoDocuments from '../../../../atoms/no-doc-placeholder';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { UserRole } from '../../../../../store/auth/types';

import { BiometricResidencePermitDocList, DocAccessType, IFollowUpDocuments } from '../../../../../types';

interface IProps {
  userAccess?: DocAccessType;
  documents: IFollowUpDocuments['afterArrival']['biometricResidencePermit'];

  userRole?: UserRole;

  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;

  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}
const BiometricResidencePermit = (props: IProps) => {
  const { documents: biometricResidencePermitDocs, userAccess, userRole } = props;

  const visibleDocs = getVisible({ documentsHash: biometricResidencePermitDocs, userAccess, userRole });

  const hasDocs = visibleDocs.length > 0;
  const hasDeletedDocs = hasDeleted(biometricResidencePermitDocs);

  const docNodes: React.ReactNode[] = [];

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if (userAccess && !hasDocs) {
    return null;
  }

  if (hasDocs) {
    docNodes.push(
      ...visibleDocs.map(
        (biometricResidencePermit: BiometricResidencePermitDocList, biometricResidencePermitIndex: number) => {
          const { key: docKey, item } = biometricResidencePermit;
          return (
            <FingerWithApprove
              id={`biometric-residence-permitDocs-${docKey}`}
              key={`biometric-residence-permitDocs-${docKey}`}
              status={getFingerStatus(item)}
              isProcessingPdf={item.isProcessingPdf}
              reason={item.reason}
              fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
              fileNames={item.fileNames}
              label={`Biometric Residence Permit ${
                Object.keys(biometricResidencePermitDocs ?? {}).length > 1
                  ? biometricResidencePermitIndex > 0
                    ? biometricResidencePermitIndex + 1
                    : ''
                  : ''
              }`}
              canUpload={props.canUpload}
              canOpen={props.canOpen}
              canApprove={props.canApprove}
              canReject={props.canReject}
              isDeleting={props.isDeleting}
              canAcknowledge={false}
              onUploadClick={() => {
                props.onUploadClick(docKey);
              }}
              onOpenClick={() => {
                props.onOpenClick(docKey);
              }}
              onApproveClick={() => {
                props.onApproveClick(docKey);
              }}
              onRejectClick={() => {
                props.onRejectClick(docKey);
              }}
              onRescindRejectClick={() => {
                props.onRescindRejectClick(docKey);
              }}
              onDeleteClick={() => {
                props.onDeleteClick(docKey);
              }}
              onAcknowledgeClick={() => {}}
              userRole={props.userRole}
              deletedByTTL={item.deletedByTTL}
              notBeReceivingReasonExists={item.hasOwnProperty('notBeReceivingReason')}
            >
              {item.dateOfIssue && item.untilDate ? (
                <>
                  <SummaryRow
                    key={`date-of-issue-${docKey}`}
                    label="Date of issue"
                    fullLabel="What is the date of issue?"
                    value={getFormatDateFromStoreDate(item.dateOfIssue)}
                  />

                  <SummaryRow
                    key={`until-date-${docKey}`}
                    label="Valid until"
                    fullLabel="What is the valid until date?"
                    value={getFormatDateFromStoreDate(item.untilDate)}
                  />
                </>
              ) : (
                <SummaryRow
                  key={`will-not-receiving-reason-${docKey}`}
                  label="Reason why BRP is not required"
                  fullLabel="Please explain why you do not need a BRP"
                  value={item.notBeReceivingReason}
                />
              )}
            </FingerWithApprove>
          );
        },
      ),
    );
  }

  return (
    <>
      <Section key={`before-travel`} label={'Scan of BRP issued to student after arrival'} canEdit={false} warning={''}>
        {hasDocs ? docNodes : <NoDocuments />}
      </Section>
    </>
  );
};

export default BiometricResidencePermit;
